/* BI-10 · WORKSPACE SETTINGS & SUPPORT
   Retention shown as a schedule, data requests with their SLA, and account
   closure that exports first and protects issued gifts.
   Titled « Votre espace », the word of Compte et accès's door to it (FQ-I4 vet, F3): « Workspace » is CW-03's retired word.

   Two additions past the v5 frame, both from the addenda:
   - D-47 (batch 8) + batch 9 ①: a single-establishment workspace gets
     « Inviter quelqu’un » → /equipe and « Connecter un outil » → /integrations
     here, because Équipe and Intégrations have left its short sidebar. The
     condition lives in the seam.
   - « Panier moyen (estimation) » (batch 9 ①, wired at batch 11): the merchant
     types one amount; it persists through getPanierMoyen / setPanierMoyen
     (`bmr.panier.<monde>`) and feeds the estimated-value line in Résultats.
     Empty means no estimate is shown — never an invented figure. */
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Card, Field, Input, KV, PageHeader } from '@/ui'
import { getPanierMoyen, setPanierMoyen } from '@/lib/campaign'
import { scopedPath, useScope } from '@/lib/scope'
import { useBill } from './ParamShell'

/** « 42,5 » ↔ 42.5 — the merchant types a French amount, the seam holds a number. */
const toField = (n: number | null) => (n === null ? '' : String(n).replace('.', ','))
const toAmount = (raw: string): number | null => {
  const n = Number(raw.replace(/\s|€/g, '').replace(',', '.'))
  return Number.isFinite(n) && n > 0 ? n : null
}

export default function BI10Espace() {
  const b = useBill()
  const [scope] = useScope()
  const [panier, setPanier] = useState(() => toField(getPanierMoyen()))

  /* committed on blur, not per keystroke: a half-typed « 4 » must never reach
     Résultats as an estimate */
  const commit = () => {
    const amount = toAmount(panier)
    setPanierMoyen(amount)
    setPanier(toField(amount))
  }

  return (
    <section data-frame="BI-10" style={{ display: 'grid', gap: 14 }}>
      <PageHeader title="Votre espace" />
      <Card>
        <KV rows={b.workspace.map(r => [
          r.label,
          r.link
            ? <>
                {r.to
                  ? <Link to={scopedPath(r.to, scope)} className="btn btn-ghost sm" style={{ padding: 0 }}>{r.link}</Link>
                  : <button type="button" className="btn btn-ghost sm" style={{ padding: 0 }}>{r.link}</button>}
                {r.value}
              </>
            : r.value,
        ])} />
      </Card>
      <Field label="Panier moyen (estimation)"
        help="Facultatif. Multiplié par vos participations pour estimer une valeur dans Résultats. Laissé vide, aucune estimation n’est affichée.">
        {id => (
          <Input id={id} inputMode="decimal" value={panier}
            onChange={e => setPanier(e.target.value)} onBlur={commit} />
        )}
      </Field>
    </section>
  )
}
